import { Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { SchedulesTypes } from '@mode/shared/contract-common';
import { getOwnerUsername } from '@mode/shared/util-js';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { SchedulesFacade } from '@mode/shared/schedules/contract';
import * as ScheduleActions from './+state/schedule/schedule.actions';
import * as ScheduleSelectors from './+state/schedule/schedule.selectors';

@Injectable()
export class SchedulesFacadeService extends SchedulesFacade {
  override readonly schedules$ = this.store.select(ScheduleSelectors.selectSchedules);
  schedulesPagination$ = this.store.select(ScheduleSelectors.selectSchedulesPagination);
  isSchedulesLoading$ = this.store.select(ScheduleSelectors.selectIsLoading);
  openScheduleModal$ = this.actions$.pipe(ofType(ScheduleActions.openScheduleModal));
  query$ = this.store.select(ScheduleSelectors.selectSchedulesQuery);
  filters$ = this.store.select(ScheduleSelectors.selectSchedulesFilters);
  sort$ = this.store.select(ScheduleSelectors.selectSchedulesSort);
  hasDeletedSchedules$ = this.store.select(ScheduleSelectors.selectHasDeletedSchedules);
  scheduleIntervalThreshold$ = this.store.select(ScheduleSelectors.selectMinimumScheduleInterval);
  availableIntervals$ = this.store.select(ScheduleSelectors.selectAvailableIntervals);

  constructor(
    private readonly store: Store,
    private readonly actions$: Actions
  ) {
    super();
  }

  loadSchedules(page = 1, query = '', filters = '', sort = ''): void {
    this.store.dispatch(
      ScheduleActions.loadSchedules({
        username: getOwnerUsername(window.document) || '',
        page,
        query,
        filters,
        sort,
      })
    );
  }

  deleteSchedule({ token, deleteForm }: SchedulesTypes.Schedule): void {
    this.store.dispatch(ScheduleActions.deleteSchedule({ token, deleteForm }));
  }

  openScheduleModal({ token, reportToken }: SchedulesTypes.Schedule) {
    this.store.dispatch(ScheduleActions.openScheduleModal({ token, reportToken }));
  }

  openWorkspaceSettingScheduleModal({ token, reportToken }: SchedulesTypes.Schedule) {
    this.store.dispatch(ScheduleActions.openWorkspaceSettingScheduleModal({ token, reportToken }));
  }

  bulkDeleteSchedule(payload: SchedulesTypes.BulkDeleteResource): void {
    this.store.dispatch(ScheduleActions.bulkDeleteSchedule({ payload }));
  }

  updateScheduleSort(sortData: Sort): void {
    const sort = `${sortData.active === 'id' ? 'token' : sortData.active}:${sortData.direction || 'asc'}`;
    this.store.dispatch(ScheduleActions.updateSchedulesSort({ sort }));
  }

  updateSchedulesFilter(filter: string): void {
    this.store.dispatch(ScheduleActions.updateSchedulesFilter({ filter }));
  }

  loadScheduleIntervalThreshold(accountID: string): void {
    this.store.dispatch(ScheduleActions.loadScheduleIntervalThreshold({ accountID }));
  }

  updateScheduleIntervalThreshold(accountID: string, interval: string): void {
    this.store.dispatch(ScheduleActions.updateScheduleIntervalThreshold({ accountID, interval }));
  }
}
